
export interface StateSearchProps {
  value: string
  onChange: (value: string) => void
}

export function StateSearch({ value, onChange }: StateSearchProps) {
  return (
    <div className="p-2 border-b flex-shrink-0">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Search positions"
        placeholder="Search positions"
        className="w-full rounded border border-basic bg-surface p-2 text-sm text-primary placeholder:text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus"
        data-testid="state-selector-input"
      />
    </div>
  )
}
